import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { DOC_CHAT, DOC_COMPARE } from '../../Constants/commonConstants';

const STORAGE_KEYS = {
  [DOC_CHAT]: 'backToID_docchat',
  [DOC_COMPARE]: 'backToID_doccompare',
};

export const useBackToID = (product) => {
  const location = useLocation();

  // Store the current path with search if it contains uuid parameter
  const storeCurrentPath = useCallback(() => {
    const { pathname, search } = location;
    const fullPath = `${pathname}${search}`;

    // Check if the URL search params contain uuid key
    const urlParams = new URLSearchParams(search);
    const hasUuid = urlParams.has('uuid');

    if (hasUuid && product && STORAGE_KEYS[product]) {
      localStorage.setItem(STORAGE_KEYS[product], fullPath);
    }
  }, [location, product]);

  // Get the stored back path for the specific product
  const getBackPath = useCallback(() => {
    if (product && STORAGE_KEYS[product]) {
      return localStorage.getItem(STORAGE_KEYS[product]);
    }
    return null;
  }, [product]);

  // Clear the stored path for the specific product
  const clearBackPath = useCallback(() => {
    if (product && STORAGE_KEYS[product]) {
      localStorage.removeItem(STORAGE_KEYS[product]);
    }
  }, [product]);

  // Auto-store current path when location changes
  useEffect(() => {
    storeCurrentPath();
  }, [storeCurrentPath]);

  return {
    storeCurrentPath,
    getBackPath,
    clearBackPath,
  };
};
